module.exports = "//public.getcloudapp.com/packs/media/images/annotate-active-6256c16aed40d4274a5bba33e0b723f7.svg";